// Flyers shown in the homepage "Featured Events" carousel.
// Uses same date filtering logic as Services section - items drop off automatically after endDate.
const FeaturedEventsData = [
  {
    id: 'janmashtami-2026',
    tag: 'Grand Celebration',
    title: 'Grand Janmashtami Celebrations',
    desc: 'Join us for the grand celebration of Lord Krishna\'s appearance day with special programs, kirtans, and festivities.',
    startDate: '2026-09-05',
    endDate: '2026-09-05',
    time: 'All Day',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Everyone Is Welcome',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/ad6af72c_janmashtami_Mahotsav.png',
    link: '/USA/Janmashtami',
    registrationUrl: '/USA/Janmashtami',
  },
  {
    id: 'anniversary-11th-2026',
    tag: 'Musical Night',
    title: '11th Anniversary Celebration',
    desc: 'Bhajan Jamming & Bollywood Classic Melodies. Live Singing Performance. Saturday, Sept 5th, 7:00 – 9:00 pm.',
    startDate: '2026-09-05',
    endDate: '2026-09-05',
    time: '7:00 PM - 9:00 PM',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Musical Night',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/97153409_11-Anniversary.png',
    link: '/USA/Anniversary11th',
  },
  {
    id: 'janmashtami-parking-2026',
    tag: 'Event Info',
    title: 'Janmashtami Parking & Map Guide',
    desc: 'Parking details & venue map for Grand Janmashtami 2026. On-site parking $15. Free parking + shuttle at Primerica.',
    startDate: '2026-09-05',
    endDate: '2026-09-05',
    time: 'Event Day',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Parking Info',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/87797f71_onsite_partiking_fee.png',
    link: '/USA/JanmashtamiParking',
  },
  {
    id: 'radha-rani-chhathi-2026',
    tag: 'Festival Celebration',
    title: 'Radha Rani Chhathi',
    desc: 'Join us at Yugal Kunj for the devotional celebration of Radha Rani Chhath. View the flyer for full details of the program.',
    startDate: '2026-09-15',
    endDate: '2026-11-15',
    time: 'All Day',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Everyone Is Welcome',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/9a85c921_radha-rani-chhat.png',
    link: '/USA/upcomingevents',
  },
  {
    id: 'radhashtami-2026',
    tag: 'Satsang & Celebrations',
    title: 'Radhashtami Satsang & Celebrations',
    desc: 'Celebrate Radhashtami with satsang, devotional programs, flower poojan, special leela performances, and dinner prasad at Yugal Kunj.',
    startDate: '2026-09-19',
    endDate: '2026-09-19',
    time: 'All Day',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Everyone Is Welcome',
    image: 'https://yugalkunj.org/images/Radhashtami.png',
    link: '/USA/Radhashtami',
  },
  {
    id: 'fall-festival-2026',
    tag: 'Community Event',
    title: 'Fall Festival 2026',
    desc: 'Join us for a night of joy, community & fun for all ages! Games, face painting, bouncy house, raffle prizes & more!',
    startDate: '2026-09-25',
    endDate: '2026-09-25',
    time: 'Evening',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Family Fun',
    image: 'https://stssevastorage.blob.core.windows.net/media/hyc/events/image/1/a589b86f_Fall_Festival.jpeg',
    link: 'https://schools.procareconnect.com/form/48738787-12dc-44d7-8012-b066c872ba67',
  },
  {
    id: 'financial-literacy-2026',
    tag: 'Harmony Youth Center',
    title: 'Beyond Books: Financial Literacy for Youth',
    desc: 'Learn smart money habits! Save wisely, spend smartly, set goals, and build a bright future. Includes financial bingo, fun games, and food. Ages 7-18.',
    startDate: '2026-10-30',
    endDate: '2026-10-30',
    time: '7:30 PM - 8:30 PM',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Ages 7-18',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/5eb32162_Financial-litracy.jpeg',
    link: '/USA/upcomingevents',
    registrationUrl: 'https://schools.procareconnect.com/form/48738787-12dc-44d7-8012-b066c872ba67',
  },
  {
    id: 'dushehra-navadha-bhakti-2026',
    tag: 'Discourse Series',
    title: 'Dussehra Special Navadha Bhakti',
    desc: 'A Special Discourse Series with Gopeshwari Didi Ji on the 9 forms of devotion taught in the Ramayan by Lord Ram.',
    startDate: '2026-10-14',
    endDate: '2026-10-21',
    time: '7:00 PM - 8:30 PM',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Everyone Is Welcome',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/828324af_dushehra-2026.jpeg',
    link: '/USA/upcomingevents',
  },
  {
    id: 'navaratri-garba-night-2026',
    tag: 'Community Event',
    title: 'Navaratri Garba Night',
    desc: 'Bombay style Dandiya Raas at Yugal Kunj with a live singer and band featuring Desi Roots and Rangeet. Ambe Ma Aarti, food available for purchase and free parking.',
    startDate: '2026-10-16',
    endDate: '2026-10-16',
    time: '9:00 PM onwards',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Free Entry',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/554c4ac9_navratri-garba-2026.jpeg',
    link: '/USA/upcomingevents',
  },
  {
    id: 'dushehra-ravan-dahan-2026',
    tag: 'Festival Celebration',
    title: 'Dushehra Ravan Dahan',
    desc: 'Celebrate the victory of good over evil with the Ravan Dahan at Yugal Kunj in the divine presence of Sushri Gopeshwari Devi Ji.',
    startDate: '2026-10-20',
    endDate: '2026-10-20',
    time: '7:00 PM - 9:00 PM',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Everyone Is Welcome',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/e9c23204_ravan-dahan.jpeg',
    link: '/USA/upcomingevents',
  },
  {
    id: 'sharad-poornima-2026',
    tag: 'Satsang & Celebrations',
    title: 'Sharad Poornima & Jagadguruttam Jayanti',
    desc: 'Satsang and celebrations under the full moon at Yugal Kunj, honouring the appearance day of Jagadguru Shri Kripalu Ji Maharaj with kirtan, devotion and festivities until midnight.',
    startDate: '2026-10-25',
    endDate: '2026-10-25',
    time: '6:00 PM - Midnight',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Everyone Is Welcome',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/b5cab351_shard-purnima.jpeg',
    link: '/USA/upcomingevents',
  },
  {
    id: 'carnatic-music-fall-2026',
    tag: 'Harmony Youth Center',
    title: 'Carnatic Classical Music',
    desc: 'Learn the beauty of Carnatic Classical Music with expert guidance from experienced teacher Pallavi Bhat.',
    startDate: '2026-08-16',
    endDate: '2026-11-23',
    time: 'Sundays 2:00 PM - 3:00 PM',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Ages 5 & Up',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/9913aac1_classical_musice-20-27.png',
    link: '/USA/upcomingevents',
    registrationUrl: 'https://portalyk.yugalkunj.org/',
  },
  {
    id: 'bharatanatyam-fall-2026',
    tag: 'HYC Academy',
    title: 'Bharatnatyam Dance Classes',
    desc: 'Discover the grace, tradition, and beauty of Bharatanatyam with experienced instructor Pallavi Bhat.',
    startDate: '2026-08-16',
    endDate: '2026-11-23',
    time: 'Sundays 1:00 PM - 2:00 PM',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: '20 Sessions',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/11b48fbf_bharatnatyam_2026-27.png',
    link: '/USA/upcomingevents',
    registrationUrl: 'https://portalyk.yugalkunj.org/',
  },
  {
    id: 'dholak-fall-2026',
    tag: 'Harmony Youth Center',
    title: 'Dholak Classes',
    desc: 'Learn traditional Dholak rhythms and bring music to life with in-person and virtual classes.',
    startDate: '2026-08-16',
    endDate: '2026-11-23',
    time: 'Sundays 1:00 PM & Virtual',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: '10 Sessions',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/41606786_dholak_class_2026.png',
    link: '/USA/upcomingevents',
    registrationUrl: 'https://portalyk.yugalkunj.org/',
  },
  {
    id: 'harmonium-fall-2026',
    tag: 'Harmony Youth Center',
    title: 'Harmonium & Vocal Classes',
    desc: 'Learn singing and harmonium while exploring the beauty of Indian music with experienced instructors.',
    startDate: '2026-08-16',
    endDate: '2026-11-23',
    time: 'Sundays (Multiple Sessions)',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'All Levels Welcome',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/4d5d3f28_harmonai_vocal_2026-27.png',
    link: '/USA/upcomingevents',
    registrationUrl: 'https://portalyk.yugalkunj.org/',
  },
  {
    id: 'gurukul-fall-2026',
    tag: 'Education Program',
    title: 'Gurukul Classes',
    desc: 'Comprehensive spiritual education program for children and youth, teaching Vedic knowledge, Sanskrit, bhajans, and moral values.',
    startDate: '2026-08-16',
    endDate: '2027-05-10',
    time: 'Sundays',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Youth Program',
    image: 'https://stssevastorage.blob.core.windows.net/media/yugalkunj/gallery/image/1/8f5b150a_Gurukul-2026-27-v3.png',
    link: '/USA/upcomingevents',
    registrationUrl: 'https://portalyk.yugalkunj.org/',
  },
  {
    id: 'montessori-enrollment-2026',
    tag: 'Montessori School',
    title: 'Flowery Grove Montessori',
    desc: 'Now enrolling toddlers, preschool, and kindergarten students in a safe, nurturing Montessori environment with Vedic values.',
    startDate: '2026-08-01',
    endDate: '2027-04-26',
    time: 'Weekdays',
    location: 'Yugal Kunj, 2769 Duluth Hwy, Duluth, GA 30096',
    badge: 'Now Enrolling',
    image: 'https://stssevastorage.blob.core.windows.net/media/fgm/gallery/image/1/0f3995c8_FGMFlyer.png',
    link: 'https://flowerygrovemontessori.org/',
    registrationUrl: 'https://flowerygrovemontessori.org/',
  },
];

export default FeaturedEventsData;
